// /Users/ammadtarar/Documents/Repo/TMA/tma-fe/src/api/sitesApi.ts
import api from "./client";

import type { ApiResponse, BaseFilterParams, Paginated } from "#/types/api";
import type {
  Device,
  DeviceRegistrationPayload,
  DeviceUpdatePayload,
} from "#/types/device";
import { type ScanHistory } from "#/types/scan-history";

export const deviceApi = {
  bind: (
    id: number,
    body: DeviceRegistrationPayload
  ): Promise<ApiResponse<Device>> => api.post(`/device/${id}/bind`, body),
  update: (
    id: number,
    body: Partial<DeviceUpdatePayload>
  ): Promise<ApiResponse<Device>> => api.patch(`/device/${id}`, body),
  getAll: (
    params: BaseFilterParams
  ): Promise<ApiResponse<Paginated<Device[]>>> =>
    api.get("/device", { params }),
  getById: (id: number): Promise<ApiResponse<Device>> =>
    api.get(`device/${id}`),
  getByRegistrationCode: (code: string): Promise<ApiResponse<Device>> =>
    api.get(`device/code/${code}`),
  getHistory: (
    id: number,
    params: BaseFilterParams
  ): Promise<ApiResponse<Paginated<ScanHistory[]>>> =>
    api.get(`/scan/history/${id}`, { params }),
  analytics: (): Promise<ApiResponse<Device[]>> => api.get(`/device/analytics`),
};
